export default function capitalize(text: string): string {
	if (text !== undefined)
	return text
		.toLowerCase()
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1) + " ")
		.join("");
	else return ""
}

export function capitalizeFirst(s: string): string {
	return s.charAt(0).toUpperCase() + s.slice(1);
}
